import { AeoRecommendationFeedbackKindSchema } from "@redotech/redo-aeo-common/aeo-recommendation";
import { aeoRecommendationIdFormat } from "@redotech/redo-aeo-id";
import * as z from "zod";

export const updateAeoRecommendationFeedback = {
  name: "updateAeoRecommendationFeedback" as const,
  input: z.object({
    recommendationId: aeoRecommendationIdFormat.schema,
    kind: AeoRecommendationFeedbackKindSchema,
    comment: z.string().optional(),
  }),
  output: z.object({}),
};
